import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import * as ReportGenerationStore from '../../../../../redux/reportGeneration';
import { ReportCategories, ReportCategoryTitles } from '../utils';
import styles from './SidePanel.module.less';
import ReportListElement from './ReportListElement';
import type { IconClassName } from '../../../../generic';
import { icons } from '../../../../generic';
import type { ReportCategory } from '../../shared/types';
import { useCanDisplaySecurityOptions } from '../../hooks';

const CategoryIcons: Record<ReportCategory, IconClassName> = {
  [ReportCategories.Licensing]: icons.fileO,
  [ReportCategories.Vulnerability]: icons.shieldHalved,
  [ReportCategories.RemediationGuidance]: icons.wrench,
  [ReportCategories.SBOM]: icons.receipt,
};

/**
 * Provides the report format selection menu
 */
const ReportCategorySelection = () => {
  const dispatch = useDispatch();
  const category = useSelector(ReportGenerationStore.selectors.getCategory);

  const isSecurityAndPDFReportsEnabled = useCanDisplaySecurityOptions();

  const enabledCategories = isSecurityAndPDFReportsEnabled
    ? Object.entries(ReportCategoryTitles)
    : Object.entries(ReportCategoryTitles).filter(([key]) => key !== ReportCategories.Vulnerability);

  const onSelectCategory = (key: string) =>
    dispatch(ReportGenerationStore.actions.setCategory(key as ReportCategory));

  return (
    <div className={cx(styles.reportFormatSelection)}>
      <div className="panel-heading text-center">
        Select Report Type
      </div>
      <ul className="nav nav-minimal nav-stacked">
        {enabledCategories.map(([id, name]) =>
          <ReportListElement
            id={id}
            name={name}
            icon={CategoryIcons[id as ReportCategory]}
            isActive={category === id}
            onSelect={onSelectCategory}
          />,
        )}
      </ul>
    </div>
  );
};

export default ReportCategorySelection;
